import React from 'react';
import { Image, Shimmer } from 'react-shimmer'

export default class SearchHospitalListItem extends React.Component {
  render() {
    return (
      <a className="search-results__item" href={this.props.hospital.url}>
        <Image
          src={this.props.hospital.logo}
          fallback={<Shimmer width={40} height={40} />}
          errorFallback={() => (
            <Shimmer width={40} height={40} />
          )}
          NativeImgProps={{ className: 'search-results__avatar search-results__avatar--square', alt: this.props.hospital.name }}
        />
        <div className="search-results__item-content">
          <div className="search-results__item-title">{this.props.hospital.name}</div>
          <div className="search-results__item-subtitle">{this.props.hospital.address}</div>
        </div>
      </a>
    );
  }
}
